import React, { useCallback, useMemo } from "react";
import { Autocomplete, TextField, Grid, FormControl } from "@mui/material";

const PortfolioFilters = ({
  fundVal,
  StrategeyVal,
  StrategeyTypename,
  fundOptions,
  strategyOptions,
  StrategyType,
  isStrategist,
  disableStrategyButton,
  StrategyName,
  handleFundChange,
  handleStrategyChange,
  handleSideChange,
}) => {
  return (
    <Grid container spacing={2}>
      {!isStrategist && (
        <Grid size={{ xs: 1.5 }}>
          <FormControl fullWidth>
            <Autocomplete
              disableClearable
              value={fundVal}
              ListboxProps={{
                sx: { fontSize: 12 },
              }}
              sx={{
                "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                  fontSize: 12,
                },
              }}
              onChange={handleFundChange}
              options={fundOptions}
              renderInput={(params) => (
                <TextField {...params} variant="standard" value={fundVal} label="Funds" />
              )}
            />
          </FormControl>
        </Grid>
      )}
      <Grid size={{ xs: 1.5 }}>
        <FormControl fullWidth>
          <Autocomplete
            disableClearable
            value={StrategeyVal}
            ListboxProps={{
              sx: { fontSize: 12 },
            }}
            sx={{
              "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                fontSize: 12,
              },
            }}
            onChange={handleStrategyChange}
            disabled={
              isStrategist
                ? false
                : disableStrategyButton || fundVal === "" || !StrategyName || StrategyName?.length < 1
            }
            options={strategyOptions}
            renderInput={(params) => (
              <TextField {...params} variant="standard" value={StrategeyVal} label="Strategy" />
            )}
          />
        </FormControl>
      </Grid>
      <Grid size={{ xs: 1.5 }}>
        <FormControl fullWidth>
          <Autocomplete
            disableClearable
            value={StrategeyTypename}
            ListboxProps={{
              sx: { fontSize: 12 },
            }}
            sx={{
              "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                fontSize: 12,
              },
            }}
            onChange={handleSideChange}
            disabled={
              isStrategist
                ? false
                : disableStrategyButton || fundVal === "" || !StrategyName || StrategyName?.length < 1
            }
            options={StrategyType}
            renderInput={(params) => (
              <TextField {...params} variant="standard" value={StrategeyTypename} label="Side" />
            )}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default React.memo(PortfolioFilters);
